/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";
import { renderErrorMsg } from "../../../assets/component/renderErrorMsg.js";

export function RenderOrgPassword(state, func, textObj) {
  if (!state || !func) return;

  if (state.loading) {
    return (
      <div className="OrgPassword-emptyPage">
        <div className="OrgPassword-center">
          <div className="OrgPassword-btm-load"></div>
        </div>
      </div>
    );
  }
  return (
    <div className="OrgPassword-contentContainer">
      <div className="OrgPassword-contentHeader">
        <div className="OrgPassword-info">{textObj.info}</div>
        <div className="OrgPassword-submitBtn" onClick={func.submitPwBtnClick}>
          {textObj.submitBtn}
        </div>
      </div>

      <div className="OrgPassword-content">
        <div className="OrgPassword-subheading">{textObj.subheading[0]}</div>
        <div className="OrgPassword-inputFieldContainer">
          <input
            type="password"
            className="OrgPassword-inputField"
            placeholder={textObj.inputField[0]}
            value={state.orgPw.pw}
            onChange={func.handlePw}
          />
        </div>
        {renderErrorMsg(state.errMsg.oldPassword.msg)}

        <div className="OrgPassword-subheading">{textObj.subheading[1]}</div>
        <div className="OrgPassword-inputFieldContainer">
          <input
            type="password"
            className="OrgPassword-inputField"
            placeholder={textObj.inputField[1]}
            value={state.orgPw.newPw}
            onChange={func.handleNewPw}
          />
        </div>
        {renderErrorMsg(state.errMsg.newPassword.msg)}

        <div className="OrgPassword-subheading">{textObj.subheading[2]}</div>
        <div className="OrgPassword-inputFieldContainer">
          <input
            type="password"
            className="OrgPassword-inputField"
            placeholder={textObj.inputField[2]}
            value={state.orgPw.reNewPw}
            onChange={func.handleReNewPw}
          />
        </div>
        {renderErrorMsg(state.errMsg.reNewPw.msg)}

        <div className="OrgPassword-completed">
          {renderCompletedIcon(state.submitedBool.pw, textObj.CompletedIcon)}
        </div>
      </div>

      <div className="OrgPassword-footer" />
    </div>
  );
}
function renderCompletedIcon(bool, text) {
  if (!bool) return;
  return <div>{text}</div>;
}
